import {Component, OnInit, ViewChild} from '@angular/core';
import {Table} from 'primeng/table';
import {Router} from '@angular/router';
import {SelectItem} from 'primeng/api';
import {AdmsbKpi, AdmsbKpiConteo} from '../../../_models/admsb-kpi';
import {AdmsbTitularListado} from '../../../_models/admsb-titular-listado';
import {AdmsbListadoService} from '../../../_services/admsb-listado.service';
import {ListaService} from '../../../_services/lista.service';
import {ListaItem} from '../../../_models/lista-item';

@Component({
  selector: 'app-admsb-listado',
  templateUrl: './admsb-listado.component.html',
  styleUrls: ['./admsb-listado.component.scss']
})
export class AdmsbListadoComponent implements OnInit {

  @ViewChild('dt') tabla: Table;

  /** Apariencia (ícono/color) por widget, no la trae el backend */
  private readonly apariciaKpiPorWidget: {
    [widget: string]: Pick<AdmsbKpi, 'icono' | 'iconoImg' | 'colorTexto' | 'colorFondoInsignia' | 'etiquetaValor'>
  } = {
    Usuarios: {icono: 'fa fa-user-o', colorTexto: '#6f6acd', colorFondoInsignia: 'rgba(111,106,205,0.16)', etiquetaValor: 'Solicitudes'},
    Pasarela: {
      iconoImg: 'assets/icons/ico-tareas-de-cierre-check-list-hoja-documento-archivo.svg',
      colorTexto: '#1ab16a',
      colorFondoInsignia: 'rgba(80,233,159,0.12)',
      etiquetaValor: 'Usuarios'
    },
    MTD001: {
      iconoImg: 'assets/icons/preaprobados/ico-vincular-enlace-link-liga-vinculo.svg',
      colorTexto: '#f17f29',
      colorFondoInsignia: 'rgba(241,127,41,0.16)',
      etiquetaValor: 'Usuarios'
    },
    MTD002: {
      iconoImg: 'assets/icons/db-etapa2-verde.svg',
      colorTexto: '#6f6acd',
      colorFondoInsignia: 'rgba(111,106,205,0.12)',
      etiquetaValor: 'Usuarios'
    },
    MTD003: {
      iconoImg: 'assets/icons/ico-recibo-factura-comprobante.svg',
      colorTexto: '#326fd1',
      colorFondoInsignia: 'rgba(50,111,209,0.12)',
      etiquetaValor: 'Usuarios'
    },
  };

  /** Apariencia usada cuando el widget del backend no está mapeado */
  private readonly apariciaKpiGenerica: Pick<AdmsbKpi, 'icono' | 'iconoImg' | 'colorTexto' | 'colorFondoInsignia' | 'etiquetaValor'> = {
    icono: 'fa fa-bar-chart',
    colorTexto: '#6c757d',
    colorFondoInsignia: 'rgba(108,117,125,0.16)',
    etiquetaValor: 'Usuarios'
  };

  kpis: AdmsbKpi[] = [];

  /** Listado de titulares de la página actual */
  titulares: AdmsbTitularListado[] = [];

  /** Total de registros que coinciden con la búsqueda */
  totalRegistros = 0;

  cargando = false;

  filas = 10;

  /** Opciones del dropdown de tipo de documento */
  tiposDocumento: SelectItem[] = [];

  /** Valor del filtro por tipo de documento */
  filtroTipoDocumento: string | null = null;

  /** Valor del filtro por número de documento */
  filtroNumeroDocumento = '';

  constructor(
    private router: Router,
    private listadoServicio: AdmsbListadoService,
    private listaServicio: ListaService,
  ) {
  }

  ngOnInit(): void {
    this.listaServicio.getMasterDetails('ListasTiposDocumentos').subscribe(res =>
      this.tiposDocumento = res.map((s: ListaItem) => ({label: s.nombre, value: s.codigo})));

    this.listadoServicio.conteoPorEstadoFinal().subscribe(res =>
      this.kpis = res.map((c: AdmsbKpiConteo) => ({
        ...(this.apariciaKpiPorWidget[c.widget] || this.apariciaKpiGenerica),
        insignia: c.titulo || c.widget,
        valor: c.valor,
      })));
  }

  editar(row: AdmsbTitularListado): void {
    this.router.navigate(['apl/administrador-servicios-bancarios/titular/' + row.idTerceroUPPasarela]);
  }

  /**
   * Maneja el evento de carga del p-table consultando el buscador de negocioAPL.
   * Cada filtro se envía de forma independiente
   */
  cargarPagina(event: { first: number, rows: number }): void {
    const numeroDocumento = this.filtroNumeroDocumento.trim();

    this.cargando = true;
    this.listadoServicio.buscar({
      codigoTipoDocumento: this.filtroTipoDocumento || null,
      numeroDocumento: numeroDocumento || null,
      validarEstadoFinal: true,
      pagina: Math.floor(event.first / event.rows),
      cantidad: event.rows,
    }).subscribe(res => {
      this.titulares = res.data;
      this.totalRegistros = res.total;
      this.cargando = false;
    }, () => {
      this.titulares = [];
      this.totalRegistros = 0;
      this.cargando = false;
    });
  }

  /**
   * Aplica los filtros actuales y regresa la tabla a la primera página.
   */
  aplicarFiltros(): void {
    if (this.tabla) {
      this.tabla.first = 0;
    }
    this.cargarPagina({first: 0, rows: this.filas});
  }

  /**
   * Restablece los filtros y vuelve a traer el listado completo.
   */
  limpiarFiltros(): void {
    this.filtroTipoDocumento = null;
    this.filtroNumeroDocumento = '';
    if (this.tabla) {
      this.tabla.first = 0;
    }
    this.cargarPagina({first: 0, rows: this.filas});
  }

}
